const o = {
  button: "button",
  dateInput: "date_input",
  dateRangeInput: "date_range_input",
  authCheckbox: "auth_checkbox",
  checkbox: "checkbox",
  textarea: "textarea",
  radio: "radio",
  choiceBox: "choice_box",
  textInput: "text_input",
  passwordInput: "password_input",
  passwordErrorMessage: "password_error_message",
  phoneNumberInput: "phoneNumber_input",
  informer: "informer",
  dialog: "dialog",
  closeButton: "close_button",
  logoButton: "logo_button",
  tab: "tab",
  tooltip: "tooltip",
  uploadFile: "upload_file",
  radioGroup: "radio_group",
  formSelect: "form_select",
  cookiesConsent: "cookies_consent",
  alertBanner: "alert_banner",
  switch: "switch"
};
export {
  o as TEST_IDS
};
//# sourceMappingURL=testIds.mjs.map
